// TIBECO - Ferestre și Uși - Mock Data
// Generat pentru compania TIBECO specializată în producția și instalarea de ferestre și uși

// Echipa TIBECO (11 angajați)
const tibecoEmployees = [
  {
    id: 1,
    name: 'Aostăcioaei Dumitru - Ciprian',
    position: 'Manager General & Co-Proprietar',
    department: 'Management',
    email: 'ciprian.aostacioaei@tibeco.ro',
    phone: '+40 721 001 001',
    specialization: 'Management proiecte, relații cu clienții',
    status: 'Activ',
    startDate: '2020-01-15',
    salary: '6500 RON',
    avatar: '/avatars/ciprian.jpg',
    skills: ['Leadership', 'Management Proiecte', 'Relații Clienți', 'Strategie Business'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: '08:00-12:00',
      sunday: 'Liber'
    }
  },
  {
    id: 2,
    name: 'Bărbosu Mihăiță - Daniel',
    position: 'Șef Echipă Producție',
    department: 'Producție',
    email: 'daniel.barbosu@tibeco.ro',
    phone: '+40 721 002 002',
    specialization: 'Supervisare fabricație ferestre/uși',
    status: 'Activ',
    startDate: '2020-03-10',
    salary: '4200 RON',
    avatar: '/avatars/daniel.jpg',
    skills: ['Supervisare Producție', 'Control Calitate', 'Organizare Echipă', 'Fabricație PVC'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 3,
    name: 'Cazacu Denisa - Elena',
    position: 'Responsabil Administrativ',
    department: 'Administrație',
    email: 'denisa.cazacu@tibeco.ro',
    phone: '+40 721 003 003',
    specialization: 'Contabilitate, documente, resurse umane',
    status: 'Activ',
    startDate: '2021-02-01',
    salary: '3800 RON',
    avatar: '/avatars/denisa.jpg',
    skills: ['Contabilitate', 'Resurse Umane', 'Administrare Documente', 'Legislație'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 4,
    name: 'Cojocariu Beniamin',
    position: 'Tehnician Specialist',
    department: 'Producție',
    email: 'beniamin.cojocariu@tibeco.ro',
    phone: '+40 721 004 004',
    specialization: 'Montaj ferestre, finisaje',
    status: 'Activ',
    startDate: '2021-06-15',
    salary: '3500 RON',
    avatar: '/avatars/beniamin.jpg',
    skills: ['Montaj Ferestre', 'Finisaje', 'Măsurători Precizie', 'Tâmplărie PVC'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 5,
    name: 'Filip Paul - Ionel',
    position: 'Inginer Proiecte',
    department: 'Tehnică',
    email: 'ionel.filip@tibeco.ro',
    phone: '+40 721 005 005',
    specialization: 'Proiectare tehnică, măsurători',
    status: 'Activ',
    startDate: '2020-09-01',
    salary: '4800 RON',
    avatar: '/avatars/ionel.jpg',
    skills: ['Proiectare CAD', 'Măsurători Tehnice', 'Calcule Structurale', 'AutoCAD'],
    workingHours: {
      monday: '08:00-17:00',
      tuesday: '08:00-17:00',
      wednesday: '08:00-17:00',
      thursday: '08:00-17:00',
      friday: '08:00-17:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 6,
    name: 'Loghin Petrică - Ionuț',
    position: 'Operator Producție',
    department: 'Producție',
    email: 'ionut.loghin@tibeco.ro',
    phone: '+40 721 006 006',
    specialization: 'Fabricație profile, tăiere',
    status: 'Activ',
    startDate: '2022-01-10',
    salary: '3200 RON',
    avatar: '/avatars/ionut.jpg',
    skills: ['Mașini CNC', 'Tăiere Profile', 'Fabricație PVC', 'Control Calitate'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 7,
    name: 'Moroșan Noemia',
    position: 'Marketing & Vânzări',
    department: 'Marketing',
    email: 'noemia.morosan@tibeco.ro',
    phone: '+40 721 007 007',
    specialization: 'Promovare, relații clienți',
    status: 'Concediu maternal',
    startDate: '2021-04-15',
    salary: '3600 RON',
    avatar: '/avatars/noemia.jpg',
    skills: ['Marketing Digital', 'Social Media', 'Relații Clienți', 'Vânzări B2B'],
    workingHours: {
      monday: 'Concediu',
      tuesday: 'Concediu',
      wednesday: 'Concediu',
      thursday: 'Concediu',
      friday: 'Concediu',
      saturday: 'Concediu',
      sunday: 'Concediu'
    }
  },
  {
    id: 8,
    name: 'Murariu Iulian - Eusebiu',
    position: 'Șofer & Instalator',
    department: 'Logistică',
    email: 'eusebiu.murariu@tibeco.ro',
    phone: '+40 721 008 008',
    specialization: 'Transport, instalare la clienți',
    status: 'Activ',
    startDate: '2021-11-01',
    salary: '3400 RON',
    avatar: '/avatars/eusebiu.jpg',
    skills: ['Conducere Profesională', 'Instalare Ferestre', 'Logistică', 'Relații Clienți'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: '08:00-12:00',
      sunday: 'Liber'
    }
  },
  {
    id: 9,
    name: 'Rumega Romică',
    position: 'Operator Producție Senior',
    department: 'Producție',
    email: 'romica.rumega@tibeco.ro',
    phone: '+40 721 009 009',
    specialization: 'Sudură, asamblare cadre',
    status: 'Activ',
    startDate: '2019-08-15',
    salary: '3700 RON',
    avatar: '/avatars/romica.jpg',
    skills: ['Sudură PVC', 'Asamblare Cadre', 'Control Calitate', 'Mentorat Echipă'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Liber',
      sunday: 'Liber'
    }
  },
  {
    id: 10,
    name: 'Simion Tiberiu',
    position: 'Tehnician Mentenanță',
    department: 'Tehnică',
    email: 'tiberiu.simion@tibeco.ro',
    phone: '+40 721 010 010',
    specialization: 'Mentenanța utilajelor, reparații',
    status: 'Activ',
    startDate: '2020-12-01',
    salary: '3600 RON',
    avatar: '/avatars/tiberiu.jpg',
    skills: ['Mentenanță Utilaje', 'Reparații Electronice', 'Diagnosticare Defecte', 'Sistem Pneumatic'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: 'Pe caz',
      sunday: 'Pe caz'
    }
  },
  {
    id: 11,
    name: 'Ungureanu Ștefan',
    position: 'Instalator Specialist',
    department: 'Montaj',
    email: 'stefan.ungureanu@tibeco.ro',
    phone: '+40 721 011 011',
    specialization: 'Instalări complexe, ferestre mari',
    status: 'Activ',
    startDate: '2022-03-20',
    salary: '3800 RON',
    avatar: '/avatars/stefan.jpg',
    skills: ['Instalări Complexe', 'Ferestre Panoramice', 'Măsurători Precizie', 'Soluții Personalizate'],
    workingHours: {
      monday: '07:00-16:00',
      tuesday: '07:00-16:00',
      wednesday: '07:00-16:00',
      thursday: '07:00-16:00',
      friday: '07:00-16:00',
      saturday: '08:00-12:00',
      sunday: 'Liber'
    }
  }
];

export const mockData = {
  // Angajați TIBECO (11 persoane)
  employees: tibecoEmployees,

  // Concedii pentru echipa TIBECO
  vacations: [
    { id: 1, employee: 'Aostăcioaei Dumitru - Ciprian', startDate: '2024-08-01', endDate: '2024-08-15', days: 14, status: 'Planificat', type: 'Concediu de odihnă', requestDate: '2024-03-15', approvedBy: 'Auto-aprobat', reason: 'Concediu de vară' },
    { id: 2, employee: 'Bărbosu Mihăiță - Daniel', startDate: '2024-07-20', endDate: '2024-07-27', days: 7, status: 'Aprobat', type: 'Concediu de odihnă', requestDate: '2024-03-10', approvedBy: 'Ciprian Aostăcioaei', reason: 'Concediu planificat' },
    { id: 3, employee: 'Moroșan Noemia', startDate: '2024-01-15', endDate: '2025-01-15', days: 365, status: 'În curs', type: 'Concediu creștere copil', requestDate: '2023-12-01', approvedBy: 'Ciprian Aostăcioaei', reason: 'Concediu maternal' }
  ],

  // Clienți TIBECO - Industria construcțiilor
  customers: [
    {
      id: 1,
      name: 'SC Constructor SRL',
      type: 'B2B',
      contactPerson: 'Ing. Popescu Marius',
      email: 'office@constructor.ro',
      phone: '+40 721 123 456',
      status: 'Client fidel',
      lastContact: '2024-03-14',
      orders: 15,
      totalSpent: '45,600 RON',
      projects: ['Ansamblu Rezidențial Nord', 'Complex Offices Center'],
      tier: 'VIP',
      source: 'Recomandare',
      address: 'Str. Industriei 45, București',
      notes: 'Client B2B important, comenzi regulate pentru proiecte rezidențiale'
    },
    {
      id: 2,
      name: 'Familia Ionescu',
      type: 'B2C',
      contactPerson: 'Maria Ionescu',
      email: 'maria.ionescu@gmail.com',
      phone: '+40 731 234 567',
      status: 'Client nou',
      lastContact: '2024-03-12',
      orders: 1,
      totalSpent: '3,200 RON',
      projects: ['Apartament 3 camere'],
      tier: 'Regular',
      source: 'Facebook',
      address: 'Bd. Unirii 15, București',
      notes: 'Prima comandă, ferestre PVC pentru apartament'
    },
    {
      id: 3,
      name: 'Asociația Proprietarilor Bloc A1',
      type: 'B2B',
      contactPerson: 'Gheorghe Marinescu',
      email: 'ap.bloca1@yahoo.ro',
      phone: '+40 741 234 567',
      status: 'Prospect',
      lastContact: '2024-03-10',
      orders: 0,
      totalSpent: '0 RON',
      projects: ['Reabilitare termică bloc'],
      tier: 'Prospect',
      source: 'Google Search',
      address: 'Str. Mihai Viteazu 22, Sector 2',
      notes: 'Interesați de ferestre pentru reabilitare termică'
    },
    {
      id: 4,
      name: 'Casa Vasilescu',
      type: 'B2C',
      contactPerson: 'Elena Vasilescu',
      email: 'elena.vasilescu@outlook.com',
      phone: '+40 751 234 567',
      status: 'Client fidel',
      lastContact: '2024-03-15',
      orders: 3,
      totalSpent: '8,900 RON',
      projects: ['Casa individuală Pipera'],
      tier: 'Premium',
      source: 'Recomandare',
      address: 'Str. Primaverii 12, Pipera',
      notes: 'Clienți satisfăcuți, au recomandat serviciile'
    }
  ],

  // Produse TIBECO - Ferestre și Uși
  products: [
    {
      id: 1,
      name: 'Fereastră PVC 3 camere',
      category: 'Ferestre PVC',
      dimensions: '120x140 cm',
      price: '450 RON',
      description: 'Fereastră PVC cu 3 camere, geam termopan, deschidere oscilo-batantă',
      inStock: true,
      estimatedTime: '7-10 zile',
      specifications: {
        profile: 'PVC 3 camere',
        geam: 'Termopan 4+16+4',
        feronerie: 'ROTO NT',
        culoare: 'Alb standard'
      }
    },
    {
      id: 2,
      name: 'Ușă de intrare blindată',
      category: 'Uși Metalice',
      dimensions: '90x200 cm',
      price: '1200 RON',
      description: 'Ușă blindată cu 3 puncte de încuiere, izolație termică și fonică',
      inStock: true,
      estimatedTime: '5-7 zile',
      specifications: {
        material: 'Oțel galvanizat',
        grosime: '7 cm',
        incuietori: '3 puncte',
        izolatie: 'Poliuretan'
      }
    },
    {
      id: 3,
      name: 'Fereastră Lemn Stratificat',
      category: 'Ferestre Lemn',
      dimensions: '100x120 cm',
      price: '680 RON',
      description: 'Fereastră din lemn stratificat, cu geam termopan, finisaj natural',
      inStock: false,
      estimatedTime: '14-18 zile',
      specifications: {
        material: 'Lemn stratificat pin',
        geam: 'Termopan 4+12+4',
        tratament: 'Lazură ecologică',
        feronerie: 'ROTO Classic'
      }
    },
    {
      id: 4,
      name: 'Ușă Interior Furnir',
      category: 'Uși Interior',
      dimensions: '80x200 cm',
      price: '320 RON',
      description: 'Ușă interior cu furnir natural, model clasic, tocuri incluse',
      inStock: true,
      estimatedTime: '3-5 zile',
      specifications: {
        material: 'MDF cu furnir stejar',
        grosime: '38 mm',
        toc: 'MDF 12 cm',
        manere: 'Incluse'
      }
    },
    {
      id: 5,
      name: 'Fereastră Panoramică',
      category: 'Ferestre Speciale',
      dimensions: '200x240 cm',
      price: '1350 RON',
      description: 'Fereastră panoramică cu geam tripan, cadru întărit, vedere maximă',
      inStock: false,
      estimatedTime: '10-14 zile',
      specifications: {
        profile: 'PVC 5 camere',
        geam: 'Tripan Low-E',
        cadru: 'Întărit cu oțel',
        tip: 'Fix + oscilo-batant'
      }
    },
    {
      id: 6,
      name: 'Ușă Sticla Securizată',
      category: 'Uși Sticla',
      dimensions: '90x200 cm',
      price: '850 RON',
      description: 'Ușă cu sticlă securizată, cadru aluminiu, design modern',
      inStock: true,
      estimatedTime: '7-10 zile',
      specifications: {
        sticla: 'Securizată 10 mm',
        cadru: 'Aluminiu anodizat',
        tip: 'Pivotant',
        finisaj: 'Mat satinato'
      }
    }
  ],

  // Comenzi și vânzări
  sales: [
    { id: 1, product: 'Fereastră PVC 3 camere', quantity: 8, amount: '3,600 RON', date: '2024-03-15', client: 'SC Constructor SRL', category: 'Ferestre PVC' },
    { id: 2, product: 'Ușă de intrare blindată', quantity: 1, amount: '1,200 RON', date: '2024-03-14', client: 'Familia Ionescu', category: 'Uși Metalice' },
    { id: 3, product: 'Fereastră Lemn Stratificat', quantity: 4, amount: '2,720 RON', date: '2024-03-13', client: 'Casa Vasilescu', category: 'Ferestre Lemn' },
    { id: 4, product: 'Ușă Interior Furnir', quantity: 6, amount: '1,920 RON', date: '2024-03-12', client: 'SC Constructor SRL', category: 'Uși Interior' },
    { id: 5, product: 'Fereastră Panoramică', quantity: 2, amount: '2,700 RON', date: '2024-03-11', client: 'Casa Vasilescu', category: 'Ferestre Speciale' }
  ],

  // Inventar materiale și componente
  inventory: [
    { id: 1, product: 'Profile PVC albe (ml)', quantity: 450, minStock: 200, status: 'În stoc', location: 'Depozit materiale', category: 'Profile', price: '25 RON/ml' },
    { id: 2, product: 'Geam termopan 4+16+4 (mp)', quantity: 15, minStock: 20, status: 'Stoc redus', location: 'Depozit sticlă', category: 'Sticlă', price: '45 RON/mp' },
    { id: 3, product: 'Feronerie ROTO NT (set)', quantity: 35, minStock: 15, status: 'În stoc', location: 'Magazie accesorii', category: 'Feronerie', price: '120 RON/set' },
    { id: 4, product: 'Garnituri etanșare (ml)', quantity: 180, minStock: 100, status: 'În stoc', location: 'Dulap componente', category: 'Garnituri', price: '8 RON/ml' },
    { id: 5, product: 'Mânere ferestre (buc)', quantity: 8, minStock: 20, status: 'Stoc critic', location: 'Magazie accesorii', category: 'Mânere', price: '35 RON/buc' },
    { id: 6, product: 'Șuruburi și dibluri (set)', quantity: 45, minStock: 25, status: 'În stoc', location: 'Cutii fixare', category: 'Fixare', price: '15 RON/set' }
  ],

  // Facturi clienți
  invoices: [
    { id: 'TIBECO-001', client: 'SC Constructor SRL', amount: '3,600.00 RON', status: 'Plătită', date: '2024-03-15', description: '8x Ferestre PVC cu montaj' },
    { id: 'TIBECO-002', client: 'Familia Ionescu', amount: '1,450.00 RON', status: 'În așteptare', date: '2024-03-14', description: 'Ușă blindată + montaj' },
    { id: 'TIBECO-003', client: 'Casa Vasilescu', amount: '3,100.00 RON', status: 'Plătită', date: '2024-03-13', description: 'Ferestre lemn + panoramică' },
    { id: 'TIBECO-004', client: 'SC Constructor SRL', amount: '2,150.00 RON', status: 'Expirată', date: '2024-03-05', description: 'Uși interior cu montaj' }
  ],

  // Campanii marketing
  campaigns: [
    { id: 1, name: 'Ferestre PVC Primăvară 2024', type: 'Facebook Ads', status: 'Activă', reach: '25,400', conversion: '12.5%', budget: '1200 RON', target: 'Proprietari case/apartamente' },
    { id: 2, name: 'Uși Blindate Securitate', type: 'Google Ads', status: 'Activă', reach: '15,800', conversion: '8.3%', budget: '900 RON', target: 'Familii cu venit mediu-ridicat' },
    { id: 3, name: 'Reabilitare Termică Blocuri', type: 'Email Marketing', status: 'Planificată', reach: '5,200', conversion: '0%', budget: '400 RON', target: 'Asociații proprietari' },
    { id: 4, name: 'Ferestre Lemn Premium', type: 'Instagram', status: 'În pregătire', reach: '8,500', conversion: '0%', budget: '600 RON', target: 'Clienți premium, case individuale' }
  ],

  // Securitate și monitorizare
  threats: [
    { id: 1, type: 'Tentativă acces neautorizat', severity: 'Medie', ip: '192.168.1.150', timestamp: '2024-03-15 09:45', status: 'Investigat', description: 'Login eșuat pe sistemul de producție' },
    { id: 2, type: 'Spam formular contact', severity: 'Scăzută', ip: '10.0.0.75', timestamp: '2024-03-15 14:20', status: 'Blocat automat', description: 'Mesaje spam pe site web' },
    { id: 3, type: 'Monitorizare utilaje', severity: 'Info', ip: 'Intern', timestamp: '2024-03-15 16:30', status: 'Normal', description: 'Verificare automată utilaje producție' }
  ],

  // Analytics website
  analytics: [
    { metric: 'Vizitatori unici', value: '2,847', change: '+18%', period: 'Această lună' },
    { metric: 'Leads generate', value: '156', change: '+12%', period: 'Această lună' },
    { metric: 'Rata de conversie', value: '5.5%', change: '+1.2%', period: 'Această lună' },
    { metric: 'Cereri de ofertă', value: '89', change: '+8%', period: 'Această lună' }
  ]
};

// Helper functions pentru formatare
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON'
  }).format(amount);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('ro-RO');
};

export const getStatusColor = (status) => {
  const colors = {
    'Activ': 'success',
    'Activă': 'success', 
    'Plătită': 'success',
    'Aprobat': 'success',
    'În stoc': 'success',
    'Normal': 'success',
    'În așteptare': 'warning',
    'Planificată': 'warning',
    'Stoc redus': 'warning',
    'În progres': 'warning',
    'Concediu': 'info',
    'Concediu maternal': 'info',
    'Monitorizat': 'info',
    'Prospect': 'info',
    'Info': 'info',
    'Expirată': 'error',
    'Stoc critic': 'error',
    'Investigat': 'error'
  };
  return colors[status] || 'default';
};

export const getDepartmentColor = (department) => {
  const colors = {
    'Management': 'primary',
    'Producție': 'secondary',
    'Administrație': 'accent-blue',
    'Tehnică': 'accent-wood',
    'Marketing': 'warning',
    'Logistică': 'info',
    'Montaj': 'success'
  };
  return colors[department] || 'gray';
};
